<template>
  <div class="new-domain-banner">
    <div class="banner-img" @click="new_link" style="cursor:pointer;">
      <div class="link-switch auto fix">
        <!-- <a @click="stop($event)" style=""
           href="/domain">注册域名</a> -->
        <!-- <a href="/trademark">注册商标</a> -->
        <!-- <a @click="stop($event)" href="https://shop.300.cn/goods/5.html">注册商标</a> -->
      </div>
      <!-- <span class="banner-title">企业经营互联网，第一步从域名开始</span> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    new_link(){
      window.open("https://www.300.cn/domain/info-intro/cn/网址")
    },
    stop(e){
      e.stopPropagation();
    }
  }
}
</script>
<style>
.new-domain-banner {
  height: 280px;
  background: #070438;
}
.new-domain-banner .banner-img {
  background: url(../../static/assets/new-banner.png);
  width: 1200px;
  height: 280px;
  margin: auto;
  text-align: center;
}

.new-domain-banner .banner-title {
  display: inline-block;
  padding-top: 66px;
  color: #fff;
  font-size: 36px;
}
.new-domain-banner .link-switch {
  font-size: 0;
  padding-top: 30px;
  margin-left: 60px;
}
.new-domain-banner .link-switch a {
  float: left;
  display: inline-block;
  color: #fff;
  font-size: 12px;
  height: 26px;
  line-height: 26px;
  width: 90px;
  text-align: center;
  background: #1e9f95;
}
.new-domain-banner .link-switch a:first-child {
  background: #18425e;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue